/**
 * The caller's visible subset of the embedded-Superset dashboard registry.
 * An empty result is a normal, ungated state (nothing to show, not an error)
 * — see AdminAnalytics.tsx.
 */

import { useAuthenticatedQuery } from '@/hooks/useAuthenticatedQuery';
import { analyticsApi, type AnalyticsDashboard } from '@/api/endpoints/analytics';

export function useAnalyticsDashboards() {
  return useAuthenticatedQuery<AnalyticsDashboard[]>({
    queryKey: ['analytics', 'dashboards'],
    queryFn: async () => (await analyticsApi.getDashboards()).items,
  });
}
